import { InputOption } from '../models/common/input-option';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TranslocoService } from '@jsverse/transloco';

export class InputOptionsHelper {
  /**
   * Retourne des input options selon un enum
   * Pour un exemple, voir BookableBy
   *
   * @param enumClass MyEnum
   * @param enumClassHumanized MyEnumHumanized
   */
  static fromEnum(enumClass, enumClassHumanized): InputOption[] {
    return Object.keys(enumClass).map((key: string) => {
      return {
        label: enumClassHumanized[enumClass[key]],
        value: enumClass[key],
      };
    });
  }

  /**
   * Comme fromEnum, mais traduit chaque libellé via transloco.
   * enumClassHumanized doit contenir des clés de traduction.
   *
   * @param enumClass MyEnum
   * @param enumClassHumanized MyEnumHumanized (clés de traduction)
   * @param translocoService service de traduction
   */
  static fromEnumTranslated(
    enumClass,
    enumClassHumanized,
    translocoService: TranslocoService,
  ): InputOption[] {
    return Object.keys(enumClass).map((key: string) => {
      return {
        label: translocoService.translate(enumClassHumanized[enumClass[key]]),
        value: enumClass[key],
      };
    });
  }

  static selectOptions$<E>(
    values: Observable<E[]>,
    valueProperty = 'id',
    labelProperty = 'name',
  ): Observable<InputOption[]> {
    return values.pipe(
      map((entities) =>
        entities.map((entity) => ({
          value: entity[valueProperty],
          label: entity[labelProperty],
        })),
      ),
    );
  }
}
